<template>
  <div>

    <el-row :gutter="12" align="middle">

      <el-col :span="10" align="center">
        <select-organisation
            label=""
            v-if="isSiteManager && allowAssign"
            v-model="org"
            full-object
            no-form />
        <div v-else>
          Org: <b>{{taskData.organisation.name}}</b>
        </div>

      </el-col>

      <el-col :span="10" align="center">

        <select-contact
          label=""
          v-if="allowAssign && isSiteManager"
          :org-id="taskData.organisation_id"
          v-model="contact"
          placeholder="Attended by..."
          :disabled="!allowAssign"
          full-object
          no-form />
        <div v-else>
          Assigned <b>{{taskData.contact.name}}</b><span v-if="taskData.contact.phone">&nbsp;{{taskData.contact.phone}}</span>
          <span v-if="taskData.contact.email" class="detail-text"><a :href="'mailto:' + taskData.contact.email +
          '?subject=RE: Site [' + taskData.site.siteName + '] for Task: ' + taskData.name +
          (taskData.started_at ? ' (started ' + this.formatFriendlyDate(taskData.started_at) + ')' : '')">{{taskData.contact.email}}</a></span>
        </div>

      </el-col>

      <el-col v-if="isSiteManager" :span="4">
        <el-button v-if="isSiteManager" :type="allowAssign ? 'success' : 'text'" :icon="allowAssign ? 'fa fa-check' : 'fa fa-edit'" @click="onSelect" :disabled="isFinished" />
      </el-col>

    </el-row>

  </div>
</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'
import WorkflowMixins from '@/mixins/WorkflowMixins'

import SelectContact from '@/components/atoms/selects/SelectContact'

export default {
  name: 'org-contact-assign',

  mixins: [SiteMixins, WorkflowMixins],

  components: {
    SelectContact
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number
    }

  },



  methods: {
    onSelect () {

      if (this.allowAssign) {
        this.saveForm(this, 'workflow/sites/checklist/edit', this.taskData.id, this.taskData, 'Contact Assigned')
      }

      this.allowAssign = !this.allowAssign
    }

  },

  watch: {
    org: function (org) {
      this.taskData.organisation = org
      this.taskData.organisation_id = org.id
    },

    contact: function (cont) {
      this.taskData.contact = cont
      this.taskData.assign_id = cont.id
      this.taskData.assign_at = this.formatDateSql(new Date())
    }
  },


  computed: {
    isFinished: function () {
      return this.rowData.percentComplete === 100
    }
  },


  data () {
    return {
      taskData: this.rowData,
      allowAssign: false,
      org: this.rowData.organisation,
      contact: this.rowData.contact
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrgContactAssign.vue?ef36a32e